import { useContext } from 'react';
import PropTypes from 'prop-types';
import { ModalGeneric, Table } from 'ypf-pas-general-ui-components';

import { deleteTemplate } from '../../services/templateWorkReport';
import { deleteTemplatesRequest } from '../../services/templateServiceRequest';
import { formatDate } from '../../utils/formatUtils';
import LoaderContext from '../../context/LoaderProvider';
import useToast from '../../hooks/useToast';
import './DeleteTemplateModal.scss';

const DeleteTemplateModal = ({
  modalDeleteTemplate,
  setModalDeleteTemplate,
  dataDeleteTemplate,
  isRequestTemplate,
  handleOnSubmitDeleteTemplate,
  setModalDeleteHide,
  applyTemplateView
}) => {
  const { setLoader } = useContext(LoaderContext);
  const { setNewToast } = useToast();

  const closeModal = () => {
    setModalDeleteTemplate(false);
    if (applyTemplateView) setModalDeleteHide(true);
  };

  const deleteTemplates = async (urlForDelete) => {
    try {
      setLoader(true);
      const templatesIds = dataDeleteTemplate.map((item) => item.id);
      const response = await urlForDelete(templatesIds);
      const successMessage =
        templatesIds.length > 1
          ? 'Las plantillas seleccionadas se han eliminado correctamente.'
          : 'La plantilla seleccionada se ha eliminado correctamente.';

      setNewToast({
        type: 'SUCCESS',
        message: response.message || successMessage
      });
      handleOnSubmitDeleteTemplate();
      setLoader(false);
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
      handleOnSubmitDeleteTemplate();
      setLoader(false);
    }
  };

  const handleOnClickPrimaryAction = () => {
    if (isRequestTemplate) {
      deleteTemplates(deleteTemplatesRequest);
    } else {
      deleteTemplates(deleteTemplate);
    }
  };

  const styleCell = ({ value }) => (
    <div
      className="row justify-content-center"
      style={{
        textAlign: 'center',
        display: 'flex'
      }}
    >
      {!value ? '-' : value}
    </div>
  );

  const columnsModal = [
    {
      Header: 'Nombre',
      accessor: 'nombrePlantilla',
      hideSort: true
    },
    {
      Header: 'N° Contrato',
      accessor: 'numeroContrato',
      hideSort: true,
      style: {
        fontWeight: '600',
        width: '180px'
      }
    },
    {
      Header: 'On Call',
      accessor: 'cantidadOnCall',
      hideSort: true,
      style: {
        width: '90px'
      },
      Cell: styleCell
    },
    {
      Header: 'Mensualizadas',
      accessor: 'cantidadMensualizada',
      hideSort: true,
      style: {
        width: '120px'
      },
      Cell: styleCell
    },
    {
      Header: 'Creadas el',
      accessor: 'fechaCreacion',
      hideSort: true,
      style: {
        width: '120px'
      },
      Cell: formatDate
    },
    {
      Header: 'N° ubic.',
      accessor: 'cantidadUbicaciones',
      hideSort: true,
      Cell: styleCell,
      style: {
        width: '120px'
      }
    }
  ];

  const columnsRequest = [
    {
      Header: 'Nombre',
      accessor: 'nombrePlantilla',
      hideSort: true
    },
    {
      Header: 'Tipo de evento',
      accessor: 'tipoEvento',
      hideSort: true,
      style: {
        fontWeight: '600',
        width: '180px'
      }
    },
    {
      Header: 'Servicios',
      accessor: 'servicios',
      hideSort: true,
      style: {
        width: '90px'
      },
      Cell: styleCell
    },
    {
      Header: 'Creada el',
      accessor: 'fechaCreacion',
      hideSort: true,
      style: {
        width: '150px'
      },
      Cell: formatDate
    }
  ];

  return (
    <ModalGeneric
      backdrop="static"
      infoModal
      onHide={() => closeModal()}
      primaryAction={handleOnClickPrimaryAction}
      primaryActionLabel="Eliminar plantilla"
      primaryActionVariant="danger"
      secondaryAction={() => closeModal()}
      secondaryActionLabel="Salir"
      show={modalDeleteTemplate}
      size="xl"
      title="Eliminar plantilla"
      variantHeader="info"
    >
      <>
        <div className="modal_template_error">
          <span>
            <b
              style={{
                color: `${'#ff6666'}`
              }}
            >
              ¿Estas seguro que queres eliminar la plantilla?
            </b>
            <br />
          </span>
        </div>
        <div>
          <Table
            columns={isRequestTemplate ? columnsRequest : columnsModal}
            data={dataDeleteTemplate}
            titleLeft
            type="light"
          />
        </div>
      </>
    </ModalGeneric>
  );
};

DeleteTemplateModal.propTypes = {
  modalDeleteTemplate: PropTypes.bool,
  dataDeleteTemplate: PropTypes.arrayOf(PropTypes.shape({})),
  isRequestTemplate: PropTypes.bool,
  applyTemplateView: PropTypes.bool,
  setModalDeleteTemplate: PropTypes.func,
  handleOnSubmitDeleteTemplate: PropTypes.func,
  setModalDeleteHide: PropTypes.func
};

DeleteTemplateModal.defaultProps = {
  modalDeleteTemplate: false,
  dataDeleteTemplate: [],
  isRequestTemplate: false,
  applyTemplateView: false,
  setModalDeleteHide: () => {},
  handleOnSubmitDeleteTemplate: () => {},
  setModalDeleteTemplate: () => {}
};
export default DeleteTemplateModal;
